import {PIXI} from '@colonist/pixi'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameMapDiceHighlightView} from './UIGameMapDiceHighlightView'
import {HexFace, Point} from '@colonist/game-mechanic-validators'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {UIGameGoToPointAnimation} from '../../ui_canvas_engine/animation/UIGameGoToPointAnimation'

export class UIGameMapDiceProbabilityView extends SectionView {
    private readonly size: number
    private readonly center: Point
    private readonly diceProbabilityView: SpriteView
    private readonly highlightDiceView: UIGameMapDiceHighlightView
    readonly hexFace: HexFace
    swapDiceProbabilityAnimation?: UIGameGoToPointAnimation

    constructor(x: number, y: number, w: number, h: number, hexFace: HexFace, container: PIXI.Container, texture: PIXI.Texture) {
        super(x, y, w, h, container, false)

        this.size = w
        this.center = new Point(x + this.size / 2, y + this.size / 2)
        this.diceProbabilityView = new SpriteView(0, 0, this.width, this.height, this, texture)

        const highlightDiceX = -this.width * 0.01
        const highlightDiceY = -this.height * 0.01
        const highlightDiceW = w * 0.96
        this.highlightDiceView = new UIGameMapDiceHighlightView(highlightDiceX, highlightDiceY, highlightDiceW, this)
        this.highlightDiceView.hide()
        this.hexFace = hexFace
    }

    highlight() {
        this.highlightDiceView.show()
    }

    removeHighlight() {
        this.highlightDiceView.hide()
    }

    resetSize() {
        this.animate(this.size)
    }

    animate(count: number) {
        const newSize = this.getAnimationSize(count)
        this.scale.x = newSize / this.size
        this.scale.y = newSize / this.size
        this.x = this.center.x - newSize / 2
        this.y = this.center.y - newSize / 2
    }

    private getAnimationSize(count: number): number {
        const maxSizeChangeRatio = 0.1
        const speedMultiplier = 0.5
        const sizeChangePercentage = 1 + Math.sin(count * speedMultiplier) * maxSizeChangeRatio
        return this.size * sizeChangePercentage
    }
}
